import React from "react";
import * as styles from "./related-product-feed-header-image.css";

export interface RelatedProductFeedHeaderImageProps {
    src: string;
    altText: string;
}

export function RelatedProductFeedHeaderImage({
    src,
    altText,
}: RelatedProductFeedHeaderImageProps): JSX.Element {
    return (
        <div data-testid="related-product-feed-header-image" className={styles.wrapper}>
            <img src={src} alt={altText} className={styles.image} />
        </div>
    );
}
